import React from "react";
import "./CustomSolutions.css";

import icono1 from "../../../assets/icons/5.png";
import icono2 from "../../../assets/icons/6.png";
import icono3 from "../../../assets/icons/7.png";

const items = [
    {id: 1, icon: icono1, titulo: "RED INTERNACIONAL | CONEXIONES ESTRATÉGICAS EN MERCADOS GLOBALES"},
    {id: 2, icon: icono2, titulo: "GESTIÓN INTEGRAL DE INVERSIONES | OPTIMIZAMOS TU RENTABILIDAD CON UN ENFOQUE PERSONAL"},
    {id: 3, icon: icono3, titulo: "SEGURIDAD JURÍDICA | CONSULTORÍA LEGAL Y DOCUMENTACIÓN RESPALDADA POR EXPERTOS"},
]

const CustomSolutions = () => {
  return (
    <section className="custom-solutions-container">
      <h2 className="custom-solutions-title">SOLUCIONES PERSONALIZADAS</h2>
      <h3 className="custom-solutions-subtitle">
        Ofrecemos servicios exclusivos y personalizados que garantizan tu éxito en el mercado inmobiliario de Dubái. Desde análisis estratégicos para maximizar el retorno de inversión hasta consultoría legal internacional, en Thorne Global Real Estate te ofrecemos soluciones integrales para que inviertas con confianza y visión a largo plazo.
      </h3>
      {items.map((item, index) => (
            <div key={index} className="custom-solutions-banner">
                <img src={item.icon} alt="Análisis Estratégico" className="custom-solutions-icon" />
                <p className="custom-solutions-text">{item.titulo}</p>
            </div>
          ))}
    </section>
  );
};

export default CustomSolutions;